
import * as $ from 'jquery';
import {safeLocalStorage} from './utils/safeLocalStorage.js';
import { isApp, isLogged, isAppSubdomain } from './utils.js';
import {setDrawers} from './utils/drawers.js';
import { setNativeFilters } from './filters/app-filters.js';
import appPdf from './utils/app_pdf.js';
import personalizeSizes from './components/personalize_sizes';
import { config } from './utils';
import { onLoad } from './utils/onLoad';
import {toggleReminderBanners} from './utils/app-capabilities.js';
import {setHighlights} from './highlights.js';

onLoad(async() => {

    if(isLogged()){
        if ( config.isFTL && safeLocalStorage.getItem('shownFTLNextSteps') === null ) {
            $('#modal-next-steps-first-publish').modal('show');
            safeLocalStorage.setItem('shownFTLNextSteps', 1);
        }

        if (!isApp() && safeLocalStorage.getItem('newRegister') !== null) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'sign_up_web'
            });
            safeLocalStorage.removeItem('newRegister');
        }
        toggleReminderBanners();
    }

    if (isApp()) {
        setNativeFilters();
        appPdf();
        personalizeSizes.init();
    }
    setDrawers();
    await setHighlights();
});
